import Input from '@/components/Common/Input';
import TelInput from '@/components/Common/TelInput';
import { Box, Paper, Typography, FormControlLabel, RadioGroup, Radio, Stack } from '@mui/material';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

export default function EmergencyCallHandlingConfig() {
  const { control } = useFormContext();

  const mode = useWatch({
    control,
    name: 'emergency_call_handling_details.mode',
    defaultValue: 'message'
  });

  return (
    <Box mt={3} display='flex' flexDirection='column' gap={2}>
      <Controller
        name='emergency_call_handling_details.mode'
        control={control}
        defaultValue='message'
        render={({ field }) => (
          <RadioGroup value={field.value} onChange={(e) => field.onChange(e.target.value)}>
            {/* OPTION 1 - MESSAGE */}
            <Paper variant='outlined' sx={{ p: 2, borderRadius: 2, mb: 2 }}>
              <FormControlLabel
                value='message'
                control={<Radio />}
                label={<Typography fontWeight={500}>End call with message</Typography>}
              />

              {mode === 'message' && (
                <Stack mt={2} direction='column' spacing={2}>
                  <Input
                    control={control}
                    name='emergency_call_handling_details.message'
                    label='Message'
                    placeholder="e.g: If you're experiencing a severe allergic reaction, excessive bleeding, or another medical emergency, please hang up and call 911 immediately. We're unable to assist with emergency situations. Goodbye."
                    multiline
                    minRows={2}
                    maxRows={8}
                    fullWidth
                  />
                  <Input
                    control={control}
                    name='emergency_call_handling_details.message_emergency_type'
                    label='Emergency Types'
                    placeholder='e.g: Chest pain, Severe bleeding'
                    fullWidth
                  />
                </Stack>
              )}
            </Paper>

            {/* OPTION 2 - TRANSFER */}
            <Paper variant='outlined' sx={{ p: 2, borderRadius: 2 }}>
              <FormControlLabel
                value='transfer'
                control={<Radio />}
                label={<Typography fontWeight={500}>Transfer to emergency number</Typography>}
              />

              {mode === 'transfer' && (
                <Stack mt={2} direction='column' spacing={2}>
                  <TelInput
                    name='emergency_call_handling_details.number'
                    label='Emergency Number'
                    control={control}
                    placeholder='e.g. +911234567890'
                    defaultCountry='US'
                    fullWidth
                  />
                  <Input
                    control={control}
                    name='emergency_call_handling_details.transfer_emergency_type'
                    label='Emergency Types'
                    placeholder='e.g: Chest pain, Severe bleeding'
                    fullWidth
                  />
                </Stack>
              )}
            </Paper>
          </RadioGroup>
        )}
      />
    </Box>
  );
}
